import { CollaboratorsApiRemoteService } from '../../Services/api/collaborators/collaborators-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class DestroyCollaboratorsUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly CollaboratorsApi: CollaboratorsApiRemoteService) {}
    

  public async handle (customerId: string): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CollaboratorsApi.destroy(customerId)

      if (response.isFailure) {
        return response
      }
  
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
